import { z } from "@/zod";
import { PHONE_NUMBER_REGEX } from "@/constants";
import { t } from "i18next";

export const normalizePhoneNumber = (value: string) =>
  value.trim().replace(/\s/g, "");

export const phoneNumber = z.string().transform((value, ctx) => {
  const normalized = normalizePhoneNumber(value);
  if (!PHONE_NUMBER_REGEX.test(normalized)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: t("validation.phone_number.invalid_format"),
    });
    return z.NEVER;
  }
  return normalized;
});

export const phoneNumberOptional = z
  .union([z.literal(""), phoneNumber])
  .nullish();
